import { render, staticRenderFns } from "./TheWorkflowApp.vue?vue&type=template&id=2f1f82c0&"
import script from "./TheWorkflowApp.vue?vue&type=script&lang=js&"
export * from "./TheWorkflowApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports